// src/features/auth/useMe.ts
import { useAppSelector } from '@/store/hooks'
import { authApi } from './authApi'
import { selectAuthToken } from './selectors'

// The only sanctioned way to fetch /users/me. Skips while there is no token in
// the store, so the request can never fly without an Authorization header
// (e.g. before rehydration finishes or after reauth cleared the tokens) —
// each such request is a guaranteed 401 that feeds the refresh cascade.
export const useMe = () => {
  // Boolean selector: token rotations must not re-render every consumer.
  const hasToken = useAppSelector((s) => Boolean(selectAuthToken(s)))
  return authApi.useMeQuery(undefined, { skip: !hasToken })
}
